module.exports = __webpack_public_path__ + "static/media/deliverTruckInactive.02a3407c.svg";